import { MarketEnum, countryIds, regionSchema } from "@mindlercare/schema";

export const getMarketBasedRegion = () => {
  const countryCode = getCountryCode();
  return countryCode === "SE" ? regionSchema.enum.SE : regionSchema.enum.XG;
};

export const getCountryCode = (): MarketEnum => {
  if (localStorage.getItem("mindlercare:market")) {
    return localStorage.getItem("mindlercare:market") as MarketEnum;
  }

  if (import.meta.env.NODE_ENV === "test") return "SE";

  if (import.meta.env.VITE_COUNTRY_CODE_MAP_ENABLED === "false") {
    // @TODO: Remove this when market selector is available for everyone in prod.
    localStorage.setItem(
      "mindlercare:market",
      import.meta.env.VITE_COUNTRY_CODE,
    );
    return import.meta.env.VITE_COUNTRY_CODE;
  }

  const countryCodeMap = JSON.parse(import.meta.env.VITE_COUNTRY_CODE_MAP);
  const { hostname } = window.location;
  const countryCode = (countryCodeMap as { [key: string]: MarketEnum })[
    hostname
  ];

  if (!countryCode) {
    throw new Error(
      "Couldn't decide countryId based on url, country code not set in environment",
    );
  }

  // @TODO: Remove this when market selector is available for everyone in prod.
  localStorage.setItem("mindlercare:market", countryCode);
  return countryCode;
};

export const countryIdFromMarket = (market: MarketEnum): number => {
  switch (market) {
    case "SE":
      return countryIds.SE;
    case "NL":
      return countryIds.NL;
    case "GB":
      return countryIds.GB;
    case "DK":
      return countryIds.DK;
    case "NO":
      return countryIds.NO;
    default:
      throw Error(`Invalid market ${market}`);
  }
};

export const marketFromCountryId = (
  countryId: number | undefined | null,
): MarketEnum | undefined => {
  switch (countryId) {
    case countryIds.SE:
      return "SE";
    case countryIds.NL:
      return "NL";
    case countryIds.GB:
      return "GB";
    case countryIds.DK:
      return "DK";
    case countryIds.NO:
      return "NO";
    default:
      return undefined;
  }
};
